import React from "react";
import "./App.css";
import "./themes.css";
import AdminUI from "./component/AdminUI";

const App = () => {
  return (
    <>
      <AdminUI />
    </>
  );
};

export default App;
